import * as React from 'react';

import TimeCommitmentEffortText from 'bundles/learner-progress/components/item/TimeCommitmentEffortText';
import type { Item } from 'bundles/learner-progress/types/Item';

import _t from 'i18n!nls/learner-progress';

type Props = {
  item: Item;
  className: string;
};

const ProjectEffortText = (props: Props) => {
  const { item, className, ...rest } = props;

  if (item.isStaffGradedSubmitted || item.isLtiSubmitted || item.isSubmitted) {
    return (
      <span {...rest} className={className}>
        {_t('Submitted')}
      </span>
    );
  }

  if (item.isStaffGradedStarted || item.isLtiStarted || item.isStarted) {
    return (
      <span {...rest} className={className}>
        {_t('Started')}
      </span>
    );
  }

  return <TimeCommitmentEffortText timeCommitment={item.timeCommitment} className={className} {...rest} />;
};

export default ProjectEffortText;
